import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  login,
  resendSignUpOTP,
  resetPassword,
  signUp,
  signupOTP,
  signUpV2,
} from './api';
import {
  LoginData,
  LoginOTPPayload,
  LoginOTPResponse,
  LoginResponse,
  ResetPasswordData,
  SignUpFlowData,
  SignUpFlowType,
  SignUpPayload,
  SignUpSuccessResponse,
} from './type';

export const useSignUp = (
  args: Omit<
    UseMutationOptions<
      { data: string },
      Error,
      { flowType: SignUpFlowType; data: SignUpFlowData }
    >,
    'mutationFn'
  >
) => {
  return useMutation({
    mutationFn: signUp,
    ...args,
  });
};

export const useSignUpV2 = (
  args?: Omit<
    UseMutationOptions<
      {
        data: string;
        user_id?: string;
        phone_verification_flag?: boolean;
        email_verification_flag?: boolean;
      },
      Error,
      { flowType: SignUpFlowType; data: SignUpFlowData; hsbcFlow?: boolean }
    >,
    'mutationFn'
  >
) => {
  return useMutation({
    mutationFn: signUpV2,
    ...args,
  });
};

export const useLogin = (
  args?: Omit<UseMutationOptions<LoginResponse, Error, LoginData>, 'mutationFn'>
) => {
  return useMutation({
    mutationFn: login,
    ...args,
  });
};

export const useSignUpOTP = (
  args?: Omit<
    UseMutationOptions<SignUpSuccessResponse, Error, SignUpPayload>,
    'mutationFn'
  >
) => {
  return useMutation({
    mutationFn: signupOTP,
    ...args,
  });
};
export const useResendSignupOTP = (
  args?: Omit<
    UseMutationOptions<LoginOTPResponse, Error, LoginOTPPayload>,
    'mutationFn'
  >
) => {
  return useMutation({
    mutationFn: resendSignUpOTP,
    ...args,
  });
};

export const useResetPassword = (
  args?: Omit<
    UseMutationOptions<LoginResponse, Error, ResetPasswordData>,
    'mutationFn'
  >
) => {
  return useMutation({
    mutationFn: resetPassword,
    ...args,
  });
};
